import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { actions } from "../../../../Redux";
import Headerbar from "../../../Components/InnerLayout/Headerbar";
import UserInterface from "../../../Components/InnerLayout/UserInterface";
import DatePicker from "react-datepicker";
import moment from "moment";
import { useHistory } from "react-router-dom";
import Input from "../../../Components/Input";
import Select from "../../../Components/Select";
import * as yup from "yup";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import DateInput from "../../../Components/DateInput";
import { MultiSelect } from "react-multi-select-component";
import ErrorContainer from "../../../Components/ErrorContainer";
import { getFormData } from "../../../../helpers";
import SingleSearchSelect from "../../../Components/SingleSearchSelect";
import ModelContainer from "../../../Components/ModelContainer";

const NewArInvoices = (params) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const pageDetail = params?.location?.state;

  const newArInvoicesOptions = useSelector(
    (state) => state?.orderInvoicesReducer?.newArInvoicesOptions
  );

  const editArInvoiceData = useSelector(
    (state) => state?.orderInvoicesReducer?.editArInvoiceData
  );

  const arInvoiceOptions =
    pageDetail?.pageType === "edit" ? editArInvoiceData : newArInvoicesOptions;

  console.log(arInvoiceOptions, "arInvoiceOptions", editArInvoiceData);
  useEffect(() => {
    if (pageDetail?.pageType === "edit")
      dispatch(actions?.getEditArInvoicesData({ id: pageDetail?.id }));
    else dispatch(actions?.getNewArInvoicesOptions());
  }, []);

  const initialScheme = {
    customer_id: "",
    purchase_order_id: "",
    tax_charged: "",
    // mail_to_customer: "",
    memo: "",
    invoice_date: "",
    transaction_date: "",
    total_tax: "",
    total_price: "",

    ar_invoice_item: [],
  };

  const [selectedCustomer, setSelectedCustomer] = useState([]);
  const [invoiceDate, setInvoiceDate] = useState(null);
  const [transactionDate, setTransactionDate] = useState(null);
  const [newARState, setNewARState] = useState(initialScheme);

  useEffect(() => {
    if (pageDetail?.pageType === "edit") {
      setNewARState({
        ...editArInvoiceData?.ar_invoice,
        tax_charged: editArInvoiceData?.tax_charged,
      });
      setInvoiceDate(
        moment(editArInvoiceData?.ar_invoice?.invoice_date).toDate()
      );
      setTransactionDate(
        moment(editArInvoiceData?.ar_invoice?.transaction_date).toDate()
      );
      setSelectedCustomer([
        editArInvoiceData?.customers?.find(
          (el) => el?.value == editArInvoiceData?.ar_invoice?.customer_id
        ) ?? [],
      ]);
      reset({
        ...editArInvoiceData?.ar_invoice,
        tax_charged: editArInvoiceData?.tax_charged,
      });
    } else {
      setValue("tax_charged", arInvoiceOptions?.tax_charged);
    }
  }, [editArInvoiceData, newArInvoicesOptions]);

  useEffect(() => {
    setValue("ar_invoice_item", newARState?.ar_invoice_item);
  }, [newARState?.ar_invoice_item]);

  const schema = yup.object().shape({
    customer_id: yup.string().required(),
    purchase_order_id: yup.string().required(),
    tax_charged: yup.string().required(),
    // mail_to_customer: yup.string().required(),
    memo: yup.string().required(),
    invoice_date: yup.string().required(),
    transaction_date: yup.string().required(),
    total_tax: yup.string().required(),
    total_price: yup.string().required(),

    ar_invoice_item: yup
      .array()
      .of(
        yup.object().shape({
          account_id: yup.string().required(),
          item_description: yup.string().required(),
          price: yup.string().required(),
          quantity: yup.string().required(),
          sub_total: yup.string().required(),
          tax_type: yup.string().required(),
          tax: yup.string().required(),
          total: yup.string().required(),
          credit_account_id: yup.string().required(),
        })
      )
      .required(),
  });

  const {
    register,
    formState: { errors },
    handleSubmit,
    reset,
    control,
    getValues,
    setValue,
    trigger,
  } = useForm({
    resolver: yupResolver(schema),
    mode: "all",
    reValidateMode: "onChange",
    defaultValues: initialScheme,
  });

  const submitData = (data) => {
    console.log(data, "oooooooooooooooo");
    if (pageDetail?.pageType === "edit")
      dispatch(actions?.postEditArInvoicesData({ data, history }));
    else dispatch(actions?.postArInvoicesData({ data, history }));
  };
  const handleAddItem = () => {
    const newItem = {
      account_id: "",
      item_description: "",
      price: "",
      quantity: "",
      sub_total: 0,
      tax_type: "",
      tax: arInvoiceOptions?.tax_charged,
      total: "",
      credit_account_id: "",
    };
    setNewARState({
      ...newARState,
      ar_invoice_item: [...newARState?.ar_invoice_item, newItem],
    });
  };

  const updateARinvoiceItem = (keyName, keyVal, rowIdx) => {
    const copyNewARstate = JSON.parse(JSON.stringify(newARState));
    const targetRow = copyNewARstate?.ar_invoice_item[rowIdx];
    targetRow[keyName] = keyVal;

    ///////////////////////////////////
    if (keyName === "quantity") {
      targetRow["sub_total"] = targetRow?.price * keyVal;
    }
    if (keyName === "price") {
      targetRow["sub_total"] = targetRow?.quantity * keyVal;
    }
    targetRow["total"] =
      targetRow?.sub_total + (targetRow?.sub_total * targetRow?.tax) / 100;

    // updating price
    copyNewARstate["total_price"] = copyNewARstate?.ar_invoice_item?.reduce(
      (acc, curr) => acc + curr?.sub_total,
      0
    );
    copyNewARstate["total_tax"] = copyNewARstate?.ar_invoice_item?.reduce(
      (acc, curr) => acc + (curr?.tax * curr?.sub_total) / 100,
      0
    );
    setValue("total_price", copyNewARstate["total_price"]);
    setValue("total_tax", copyNewARstate["total_tax"]);
    /////////////////////////////////////////////

    setNewARState(copyNewARstate);
  };

  function deleteArInvoiceItem(rowIdx) {
    const copyNewARstate = JSON.parse(JSON.stringify(newARState));
    copyNewARstate?.ar_invoice_item?.splice(rowIdx, 1);
    setNewARState(copyNewARstate);
  }
  function checkError(key, errors, idx) {
    return Object.keys(errors?.ar_invoice_item?.[idx] ?? {})?.find(
      (el) => el === key
    ) === key
      ? true
      : false;
  }
  return (
    <UserInterface>
      <div
        style={{ pointerEvents: pageDetail?.view === false ? "none" : "all" }}
        className="no-sidebar row"
        id="content"
      >
        {console.log("newState", newARState)}
        {console.log("errors", errors)}
        <Headerbar />
        <div className="inner-content row mx-0 finance-setting-chart chart-of-accounts">
          <form onSubmit={handleSubmit(submitData)}>
            <div className="container px-0">
              <div className="shadowclass mt-4 mb-2">
                <div class="row mx-0">
                  <h4 class="event-alert"> New AP Invoice </h4>
                  <div class="col-md-6 px-0 px-sm-2">
                    <ul class="ingredient-info edit-shift">
                      <SingleSearchSelect
                        label={"Customer Name"}
                        formRegister={register}
                        formError={errors}
                        formKey="customer_id"
                        selected={selectedCustomer}
                        setSelected={setSelectedCustomer}
                        options={arInvoiceOptions?.customers}
                        setValue={setValue}
                      />
                      <Input
                        label={"Purchase Order ID"}
                        formRegister={register}
                        value={newARState?.purchase_order_id}
                        onChange={(e) =>
                          setNewARState({
                            ...newARState,
                            purchase_order_id: e.target.value,
                          })
                        }
                        formError={errors}
                        formKey={"purchase_order_id"}
                      />
                    </ul>
                  </div>

                  <div class="col-md-6 px-0 px-sm-2">
                    <ul class="ingredient-info edit-shift">
                      <DateInput
                        label={"Invoice Date"}
                        formRegister={register}
                        formError={errors}
                        formKey="invoice_date"
                        setFormField={setValue}
                        dateVal={invoiceDate}
                        horizontal={true}
                        setDateVal={setInvoiceDate}
                      />
                      <DateInput
                        label={"Transaction Date"}
                        formRegister={register}
                        formError={errors}
                        formKey="transaction_date"
                        setFormField={setValue}
                        dateVal={transactionDate}
                        horizontal={true}
                        setDateVal={setTransactionDate}
                      />
                      <Input
                        label={"Memo"}
                        formRegister={register}
                        value={newARState?.memo}
                        onChange={(e) =>
                          setNewARState({
                            ...newARState,
                            memo: e.target.value,
                          })
                        }
                        formError={errors}
                        formKey={"memo"}
                      />
                    </ul>
                  </div>
                </div>

                <div class="table-responsive">
                  <table class="checklist-table remove-space inventory_table">
                    <thead>
                      <tr>
                        <th> Item ID </th>
                        <th> Account Name </th>
                        <th> Item Description </th>
                        <th> Price </th>
                        <th> Quantity </th>
                        <th> Sub Total </th>
                        <th> Tax Type </th>
                        <th> Tax </th>
                        <th> Total </th>
                        <th> Credit/Clearing Account </th>
                      </tr>
                    </thead>
                    <tbody>
                      {newARState?.ar_invoice_item?.map((row, idx) => (
                        <tr className="InventoryRow">
                          <td>{idx + 1}</td>
                          <td>
                            <div class="select-div">
                              <div class="false">
                                <select
                                  value={
                                    newARState?.ar_invoice_item[idx]?.account_id
                                  }
                                  onChange={(e) =>
                                    updateARinvoiceItem(
                                      "account_id",
                                      e.target.value,
                                      idx
                                    )
                                  }
                                  class="required"
                                >
                                  <option value={""}>Select Account</option>
                                  {arInvoiceOptions?.accounts?.map((el) => (
                                    <option value={el?.value}>
                                      {el?.label}
                                    </option>
                                  ))}
                                </select>
                                <div className="error">
                                  {checkError("account_id", errors, idx)
                                    ? "error"
                                    : ""}
                                </div>
                              </div>
                            </div>
                          </td>
                          <td>
                            <div class="false required">
                              <textarea
                                value={
                                  newARState?.ar_invoice_item[idx]
                                    ?.item_description
                                }
                                onChange={(e) =>
                                  updateARinvoiceItem(
                                    "item_description",
                                    e.target.value,
                                    idx
                                  )
                                }
                                class="required small_textarea"
                              ></textarea>
                              <div className="error">
                                {checkError("item_description", errors, idx)
                                  ? "error"
                                  : ""}
                              </div>
                            </div>
                          </td>
                          <td>
                            {" "}
                            <input
                              value={newARState?.ar_invoice_item[idx]?.price}
                              onChange={(e) =>
                                updateARinvoiceItem(
                                  "price",
                                  e.target.value,
                                  idx
                                )
                              }
                              class="required price currency invitemPrice"
                              type="text"
                            />
                            <div className="error">
                              {checkError("price", errors, idx) ? "error" : ""}
                            </div>
                          </td>
                          <td>
                            <input
                              value={newARState?.ar_invoice_item[idx]?.quantity}
                              onChange={(e) => {
                                updateARinvoiceItem(
                                  "quantity",
                                  e.target.value,
                                  idx
                                );
                              }}
                              class="required quantity currency_ing invitemQty"
                              type="text"
                            />
                            <div className="error">
                              {checkError("quantity", errors, idx)
                                ? "error"
                                : ""}
                            </div>
                          </td>
                          <td>
                            {" "}
                            <span class="sub_total_val">
                              {newARState?.ar_invoice_item[idx]?.sub_total}
                            </span>{" "}
                          </td>
                          <td>
                            {" "}
                            <div className="select-div search-select-ms">
                              <select
                                value={
                                  newARState?.ar_invoice_item[idx]?.tax_type
                                }
                                onChange={(e) => {
                                  updateARinvoiceItem(
                                    "tax_type",
                                    e.target.value,
                                    idx
                                  );
                                }}
                              >
                                <option value={""}>Select Tax Type</option>
                                {arInvoiceOptions?.tax_type?.map((el) => (
                                  <option value={el?.value}>{el?.label}</option>
                                ))}
                              </select>
                              <div className="error">
                                {checkError("tax_type", errors, idx)
                                  ? "error"
                                  : ""}
                              </div>
                            </div>{" "}
                          </td>
                          <td>
                            {" "}
                            <input
                              value={newARState?.ar_invoice_item[idx]?.tax}
                              onChange={(e) =>
                                updateARinvoiceItem("tax", e.target.value, idx)
                              }
                              class="tax_val number currency"
                              type="text"
                            />{" "}
                          </td>
                          <td className="total_val">
                            {" "}
                            {newARState?.ar_invoice_item[idx]?.total}
                          </td>
                          <td>
                            {" "}
                            <div className="select-div search-select-ms">
                              <select
                                value={
                                  newARState?.ar_invoice_item[idx]
                                    ?.credit_account_id
                                }
                                onChange={(e) => {
                                  updateARinvoiceItem(
                                    "credit_account_id",
                                    e.target.value,
                                    idx
                                  );
                                }}
                              >
                                <option value={""}>Select Account</option>
                                {arInvoiceOptions?.credit_clearing_accounts?.map(
                                  (el) => (
                                    <option value={el?.value}>
                                      {el?.label}
                                    </option>
                                  )
                                )}
                              </select>
                              <div className="error">
                                {checkError("credit_account_id", errors, idx)
                                  ? "error"
                                  : ""}
                              </div>
                            </div>{" "}
                          </td>
                          <td>
                            <a
                              onClick={() => deleteArInvoiceItem(idx)}
                              class="circle_icon red remove_single_item"
                              val="7581"
                            >
                              <i class="iconSprites cancel-icon"> </i>
                            </a>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
                <div class="my-3">
                  <button
                    onClick={handleAddItem}
                    class="btn green-btn-revert add-plus"
                    type="button"
                  >
                    <i class="i-icon"> </i> Add Item
                  </button>
                </div>

                <div class="total-price row mx-0">
                  <div class="attachment col-md-6 px-0">
                    <div class="file-button">
                      <div class="input-group fileUpload claim-date">
                        <a
                          id="upload_invoive_file"
                          class="btn bordered-btn file-button"
                        >
                          Add Attachment
                        </a>
                        <span id="invoice_file_name"></span>
                      </div>
                    </div>
                  </div>
                  <div class="paymentStatus col-md-6">
                    <table>
                      <tbody>
                        <tr>
                          <td>
                            <b> Total Tax </b>
                          </td>
                          <td class="align-right">
                            <b>
                              <span id="total_tax">
                                ${newARState?.total_tax}
                              </span>
                            </b>
                          </td>
                        </tr>
                        <tr class="grn-txt">
                          <td>
                            <b> Total </b>
                          </td>
                          <td class="align-right">
                            <strong>
                              <span id="grand_total">
                                {" "}
                                ${newARState?.total_price}
                              </span>
                            </strong>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              <div class="btn-sec-row clearfix">
                <a
                  onClick={() => history.push("/order/ar-invoices")}
                  class="btn cancel mx-2"
                >
                  Cancel
                </a>
                <button class="btn green-btn-revert mx-0" type="submit">
                  Submit
                </button>
              </div>

              <div className="accordion" id="accordionPanelsStayOpenExample">
                <div className="accordion-item">
                  <h2
                    className="accordion-header"
                    id="panelsStayOpen-headingOne"
                  >
                    <button
                      className="accordion-button"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#panelsStayOpen-collapseOne"
                      aria-expanded="true"
                      aria-controls="panelsStayOpen-collapseOne"
                    >
                      <div className="col d-flex align-items-center">
                        <h4 className="event-alert p-0 mb-0"> History </h4>
                      </div>
                    </button>
                  </h2>
                  <div
                    id="panelsStayOpen-collapseOne"
                    className="accordion-collapse collapse show"
                    aria-labelledby="panelsStayOpen-headingOne"
                  >
                    <div className="row mx-0">
                      <div className="container px-0">
                        <div className="shadowclass mt-0">
                          <div className="row justify-content-between align-items-center">
                            <div className="col-md-4">
                              <div className="search-box mt-0">
                                <input
                                  type="text"
                                  placeholder="Search"
                                  name="keyword1"
                                />
                                <input type="submit" />
                              </div>
                            </div>
                          </div>

                          <div className="table-responsive">
                            <table className="checklist-table history-table">
                              <thead>
                                <tr>
                                  <th> Start </th>
                                  <th>End</th>
                                  <th>Field</th>
                                  <th>Value</th>
                                  <th>Replacement Value</th>
                                </tr>
                              </thead>
                              <tbody></tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </UserInterface>
  );
};
export default NewArInvoices;
